export default (attributes: connect.AttributeDictionary) =>
  Object.entries(attributes).reduce(
    (acc, [key, value]) => ({ ...acc, [key.replace(/[^a-z\d]/gi, '').toLowerCase()]: value }),
    {}
  );
